export class CharacterDonationByCategory {
  categoryId: number

  categoryName: string

  totalDonation: number
}
